import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import Password from "primevue/password";
import { Form } from "@primevue/forms";
import Message from "primevue/message";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import { ref } from "vue";
import { yupResolver } from "@primevue/forms/resolvers/yup";
import seConnecterYup from "@/yup/se-connecter";
import store from "@/store";
import jwt_decode from "jwt-decode";

const IDENTIFIANTS_INCORRECTS = "Adresse mail ou mot de passe incorrect.";
const CONNEXION_IMPOSSIBLE =
  "Connexion impossible pour le moment. Réessayez dans un instant.";

// Message a afficher pour une reponse en echec de /login. L'API repond 401
// avec « Invalid credentials. » pour un mauvais couple email / mot de passe, et
// avec un message en francais pour un compte refuse (« Compte inactif. »,
// « Compte désactivé depuis la date de sortie. ») : celui-la est repris tel quel.

export default /*@__PURE__*/_defineComponent({
  __name: 'AuthLoginForm',
  emits: ["success"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const email = ref("");
const password = ref("");

const resolver = ref(yupResolver(seConnecterYup));
const loading = ref(false);
const erreur = ref("");

const messageEchec = async (res: Response) => {
  if (res.status !== 401) {
    return CONNEXION_IMPOSSIBLE;
  }

  const corps = await res.json().catch(() => null);
  const message = corps?.message;

  return message && message !== "Invalid credentials."
    ? message
    : IDENTIFIANTS_INCORRECTS;
};

const onFormSubmit = ({ valid, values }) => {
  if (!valid) {
    return;
  }

  loading.value = true;
  erreur.value = "";

  fetch(process.env.VUE_APP_API_URL + "/login", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(values),
  })
    .then(async (res) => {
      if (!res.ok) {
        erreur.value = await messageEchec(res);
        return;
      }

      const response = await res.json();
      const accessToken = response.access_token ?? response.token;
      const user = jwt_decode(accessToken) as {
        exp?: number;
        societe?: string;
      };

      // L'API peut ne pas renvoyer expires_in : on le déduit de la
      // claim `exp` du JWT pour conserver une expiration de session valide.
      const expiresIn =
        response.expires_in ??
        (user.exp ? user.exp - Math.floor(Date.now() / 1000) : 0);

      store.commit("setAuth", {
        access_token: accessToken,
        expires_in: expiresIn,
        user,
      });

      // À défaut de sélection persistée, on bascule sur la société de l'utilisateur.
      if (!localStorage.getItem("selected_societe")) {
        store.commit("domain/setSelectedSociete", user?.societe);
      }

      emit("success");
    })
    .catch((error) => {
      console.error("login error", error);
      erreur.value = CONNEXION_IMPOSSIBLE;
    })
    .then(() => {
      loading.value = false;
    });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Form), {
    resolver: resolver.value,
    onSubmit: onFormSubmit,
    class: "flex flex-col gap-4"
  }, {
    default: _withCtx(($form) => [
      _createElementVNode("div", null, [
        _cache[2] || (_cache[2] = _createElementVNode("label", {
          for: "email",
          class: "block text-surface-900 dark:text-surface-0 text-xl font-medium mb-2"
        }, "Email", -1)),
        _createVNode(_unref(InputText), {
          id: "email",
          name: "email",
          type: "text",
          placeholder: "Adresse mail",
          class: "w-full",
          modelValue: email.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event))
        }, null, 8, ["modelValue"]),
        ($form.email?.invalid)
          ? (_openBlock(), _createBlock(_unref(Message), {
              key: 0,
              severity: "error",
              size: "small",
              variant: "simple"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString($form.email.error?.message), 1)
              ]),
              _: 2
            }, 1024))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        _cache[3] || (_cache[3] = _createElementVNode("label", {
          for: "password",
          class: "block text-surface-900 dark:text-surface-0 font-medium text-xl"
        }, "Mot de passe", -1)),
        _createVNode(_unref(Password), {
          id: "password",
          name: "password",
          modelValue: password.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
          placeholder: "Mot de passe",
          toggleMask: true,
          class: "mb-4",
          fluid: "",
          feedback: false
        }, null, 8, ["modelValue"]),
        ($form.password?.invalid)
          ? (_openBlock(), _createBlock(_unref(Message), {
              key: 0,
              severity: "error",
              size: "small",
              variant: "simple"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString($form.password.error?.message), 1)
              ]),
              _: 2
            }, 1024))
          : _createCommentVNode("", true)
      ]),
      (erreur.value)
        ? (_openBlock(), _createBlock(_unref(Message), {
            key: 0,
            severity: "error",
            role: "alert"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(erreur.value), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_unref(Button), {
        loading: loading.value,
        disabled: !$form.valid,
        label: "Se connecter",
        class: "w-full",
        type: "submit"
      }, null, 8, ["loading", "disabled"])
    ]),
    _: 1
  }, 8, ["resolver"]))
}
}

})